module.exports = __webpack_public_path__ + "img/Layer 17.e2a6be90.svg";